/**
 * 👻 SECTION SNAPCHAT - Composant réutilisable
 * VERSION DISCRÈTE ET CLASSE
 */

import React from 'react';
import { motion } from 'framer-motion';
import QRCode from 'react-qr-code';

export default function SnapchatSection({ className = '', compact = false }) {
  const handleSnapchatClick = () => {
    window.open('https://www.snapchat.com/@lapetiteepi62', '_blank');
  };

  // Version compacte pour les pages comme /livraison
  if (compact) {
    return (
      <section className={`py-8 px-4 ${className}`}>
        <div className="max-w-md mx-auto">
          <motion.a 
            href="https://www.snapchat.com/@lapetiteepi62"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div 
              className="flex items-center gap-4 p-4 rounded-2xl transition-all"
              style={{
                background: 'rgba(255, 252, 0, 0.1)',
                border: '1px solid rgba(255, 252, 0, 0.3)',
                boxShadow: '0 0 20px rgba(255, 252, 0, 0.1)'
              }}
            >
              {/* QR Code petit */}
              <div className="bg-white p-2 rounded-xl shadow-lg flex-shrink-0">
                <QRCode 
                  value="https://www.snapchat.com/@lapetiteepi62"
                  size={60}
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  level="M"
                />
              </div>
              
              {/* Infos */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xl">👻</span>
                  <span className="text-yellow-400 font-bold text-base">@lapetiteepice62</span>
                </div>
                <p className="text-gray-400 text-xs">
                  Offres exclu, coulisses, nouveautés... 📸
                </p>
              </div>
              
              {/* Flèche */}
              <div className="text-yellow-400/60">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </motion.a>
        </div>
      </section>
    );
  }

  // Version complète pour les pages SEO
  return (
    <section className={`py-12 px-4 ${className}`}>
      <div className="max-w-4xl mx-auto">
        {/* Titre */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-6"
        >
          <h2 className="text-xl md:text-2xl font-bold text-white flex items-center justify-center gap-2">
            <span className="text-2xl">👻</span>
            Rejoins-nous sur Snap !
          </h2>
          <p className="text-gray-400 text-sm mt-1">
            Offres exclusives, coulisses, nouveautés... 📸
          </p>
        </motion.div>

        {/* Carte Snapchat - Version élégante */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex justify-center"
        >
          <motion.a 
            href="https://www.snapchat.com/@lapetiteepi62"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="block max-w-sm w-full"
          >
            <div 
              className="flex items-center gap-4 p-5 rounded-2xl transition-all"
              style={{
                background: 'linear-gradient(135deg, rgba(255, 252, 0, 0.15) 0%, rgba(255, 229, 0, 0.1) 100%)',
                border: '2px solid rgba(255, 252, 0, 0.3)',
                boxShadow: '0 0 30px rgba(255, 252, 0, 0.15)'
              }}
            >
              {/* QR Code */}
              <div className="bg-white p-2 rounded-xl shadow-lg flex-shrink-0">
                <QRCode 
                  value="https://www.snapchat.com/@lapetiteepi62"
                  size={80}
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  level="M"
                />
              </div>
              
              {/* Infos */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-2xl">👻</span>
                  <span className="text-yellow-400 font-black text-lg">@lapetiteepice62</span>
                </div>
                <p className="text-gray-300 text-xs mb-3">
                  Scanne ou clique pour nous ajouter !
                </p>
                <div className="flex flex-wrap gap-1">
                  <span className="px-2 py-0.5 rounded-full bg-yellow-400/20 text-yellow-300 text-[10px] font-medium">🎁 Offres exclu</span>
                  <span className="px-2 py-0.5 rounded-full bg-yellow-400/20 text-yellow-300 text-[10px] font-medium">📸 Coulisses</span>
                  <span className="px-2 py-0.5 rounded-full bg-yellow-400/20 text-yellow-300 text-[10px] font-medium">🆕 News</span>
                </div>
              </div>
            </div>
          </motion.a>
        </motion.div>
        
        <p className="text-center text-gray-500 text-xs mt-4">
          + de <span className="text-yellow-400 font-bold">500 abonnés</span> nous suivent déjà ! 🔥
        </p>
      </div>
    </section>
  );
}
